// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".short span[data-v-03dee359]{white-space:nowrap;overflow:hidden;max-width:200px;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
